import {DOM} from "./DOM";

export namespace Table {

    export interface SortingPayload {
        name: string,
        order: string
    }

    export class Helpers {

        public static triggerOnSorting(tableElement: HTMLTableElement, callBack: (sorting: SortingPayload, event: MouseEvent) => void) : void {

            const sortingTriggers = DOM.Parser.getHtmlElements('sortTrigger', tableElement, true);
            for (let i = 0; i < sortingTriggers.length; i++) {
                const trigger = sortingTriggers[i];
                trigger.addEventListener('click', (event: MouseEvent) => {
                    const sortingName = DOM.Parser.getDataByNameFromElement('by', trigger);
                    const sortingOrder = DOM.Parser.getDataByNameFromElement('order', trigger);
                    callBack({name: sortingName, order: sortingOrder}, event);
                });
            }
        }

        public static getSorting(tableElementId: string) : SortingPayload|null {

            const tableElement = document.getElementById(tableElementId);
            if (tableElement === null) { return null; }
            const sortingActive = tableElement.querySelector('.sorting-container-down.active, .sorting-container-up.active');
            if (sortingActive === null) { return null; }

            const sortingItem = DOM.Parser.getHtmlElementByClass('sortTrigger', sortingActive);
            const sortingName = DOM.Parser.getDataByNameFromElement('by', sortingItem);
            const sortingOrder = DOM.Parser.getDataByNameFromElement('order', sortingItem);
            return {name: sortingName, order: sortingOrder};
        }
    }
}